import Axios from "axios";
import { action, decorate, observable } from "mobx";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { globalStatus } from "../../../../utils/GlobalFunction";
import moment from "moment";

export default class SalesReportStore {
	AUTH = null
	agGrid = null;
	per_page = 5000;
	current_page = 1;
	list_data = null;
	total = 0;
	allColumnIds = [];
	listCustomDate = null;
	fromDate = moment().subtract(1, "month").format("YYYY-MM-DD");
	toDate =  moment().subtract(1, "days").format("YYYY-MM-DD");
	
	refreshList = () => {
		if (this.agGrid) {
			this.setupGrid(this.agGrid);
		}
	}

	//set list purpose
	setListCustomDate = (date_completed) => {
		this.listCustomDate = date_completed;
		const completedDate = this.listCustomDate?.[0].date_completed		
		this.fromDate = moment(completedDate?.[0]).format("YYYY-MM-DD");
		this.toDate = moment(completedDate?.[1]).format("YYYY-MM-DD");		
		this.refreshList();
	};


	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params
		const { api } = params
		if (this.fromDate && this.toDate) {
			this.agGrid.api.setFilterModel({
				date: { dateFrom:this.fromDate, dateTo: this.toDate, type: "inRange", filterType: "date" }
			});			
		}
		var datasource = this.createDatasource(ServerGridConfig.options)
		api.setServerSideDatasource(datasource)

	};

	// change page size, default page size is ServerGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel
		var final_sort = params.sortModel
		if (final_filter["acc_offer.status"]) {
			let values_changed = []
			final_filter["acc_offer.status"].values.forEach(x => (
				values_changed.push(globalStatus('accessory_offer_status_common_status', 'value', x))
			))
			final_filter["acc_offer.status"].values = values_changed
		}				
		
		return { final_filter, final_sort }
	}



	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request)
				var payload = {
					date_completed:{ date_from: this.fromDate, date_to:this.toDate, type: "inRange",filterType: "date" },
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					// per_page: params.request.endRow - params.request.startRow,
					per_page: 5000,
					page: Math.ceil((params.request.startRow + 1) / (params.request.endRow - params.request.startRow))
				}
				this.getList(payload).then((data) => {
					if (data.data.total === 0) { this.agGrid.api.showNoRowsOverlay() }
					else { this.agGrid.api.hideOverlay() }
					params.successCallback(data.data.data, data.data.total)
					var allColumnIds = []
					if (this.agGrid && this.agGrid.columnApi && data.data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.colId)
						})
					}
				})
			}
		}
	}

	// call api to get records
	getList = (payload) => {
		return Axios.post(`/reports/finance/finance_report`, payload).then(({ data }) => {
			if (data.data.data.length) {
				data.data.data.map((item, index) => {
					item.srno = index + 1;
					item.date_completed = item.date_completed ? moment(item.date_completed).format("DD/MM/YYYY") : "N/A";
					item.booking_model.promised_delivery_date = item.booking_model.promised_delivery_date ? moment(item.booking_model.promised_delivery_date).format("DD/MM/YYYY") : "N/A";
					return null;
				});
			}
			this.list_data =
				data.data.data.length ? data.data : null;
			this.total = data.total;
			this.current_page = data.current_page;
			return data
		});
	};

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.rowModel.rowsToDisplay.length === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.rowModel.rowsToDisplay.length > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

}

decorate(SalesReportStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	total: observable,
	allColumnIds: observable,
	setupGrid: action,
	setPageSize: action,
	getList: action,
	onFilterChanged: action,
	type: observable,
	defaultType: observable,
	setListCustomDate:action,
	listCustomDate: observable,
});
